"use client";

import { HmcTextarea } from "@adi-ctx/harmonic-core-components-react";
import { forwardRef, type Ref } from "react";

/**
 * Override the original Harmonic Textarea component:
 * - added ref for using it with useForm() hook
 * - the component can be used in Server components
 * @constructor
 */
function Textarea(props: any, ref: Ref<HTMLTextAreaElement>) {
	return (
		<div className="flex flex-col gap-1">
			{props.label && (
				<label
					className="hmc-subtitle-s"
					htmlFor="hmc-textarea-id"
					data-testid="textarea-label"
				>
					{props.label}
				</label>
			)}
			<HmcTextarea data-testid="textarea" {...props} ref={ref} label="">
				{props.children}
			</HmcTextarea>
		</div>
	);
}

export default forwardRef(Textarea);
